import React from 'react';
import { Grid } from '@material-ui/core';

import { ClientContext } from '../../ClientContext';
import { ClientSocialMediaItem } from '../components/ClientSocialMediaItem';

export function ClientSocialMedia() {
    const clientContext = React.useContext(ClientContext);

    return (
        <Grid container direction="column" spacing={3}>
            <Grid item xs={12}>
                <ClientSocialMediaItem
                    itemTitle="Taxa de conversão do IDM"
                    contextRateList={clientContext.idmConversionRateList}
                    setContextRateList={clientContext.setIdmConversionRateList} />
            </Grid>
            <Grid item xs={12}>
                <ClientSocialMediaItem
                    itemTitle="Taxa de conversão do IRS"
                    contextRateList={clientContext.irsConversionRateList}
                    setContextRateList={clientContext.setIrsConversionRateList} />
            </Grid>
        </Grid>
    );
}